import axios from '@/libvue/api/axios.js'
import * as constants from './actions'

function getDefaultState() {
  return {
    errors: {},
    status: '',
  }
}

const actions = {
  [constants.SUBSCRIPTION_REQUEST_POST]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      commit(constants.SUBSCRIPTION_REQUEST_POST)
      axios
        .post('subscription/request', data)
        .then((response) => {
          commit(constants.SUBSCRIPTION_REQUEST_POST_SUCCESS, response)
          resolve(response)
        })
        .catch((error) => {
          commit(constants.SUBSCRIPTION_REQUEST_POST_ERROR, error)
          reject(error)
        })
    }),
}

const mutations = {
  [constants.SUBSCRIPTION_REQUEST_POST]: (state) => {
    state.status = 'subscription request post'
    state.errors = {}
  },
  [constants.SUBSCRIPTION_REQUEST_POST_SUCCESS]: (state) => {
    state.status = 'success'
    state.errors = {}
  },
  [constants.SUBSCRIPTION_REQUEST_POST_ERROR]: (state, errors) => {
    state.status = 'error'
    state.errors = Object.assign({}, errors.response?.data || {})
  },
  RESET: (state) => {
    const defaultState = getDefaultState()
    Object.keys(defaultState).forEach((key) => {
      state[key] = defaultState[key]
    })
  },
}

export default {
  state: getDefaultState(),
  actions,
  mutations,
}
